import { Observable } from 'rxjs';

import { COST_CENTER_IT_PRODUCT_DEVELOP } from '@shared-constants/cost-center-constants';
import * as sharedApi from '@shared-interfaces/api';

import { ISelectOptions } from '../interfaces/internal-interfaces';
import { DatahubService } from '../services/datahub.service';

export class ApproverHandler {
  /** @description A true list of all the approvers that SAP returned */
  private allApprovers: IApproverList[] = [];

  /** @description A filtered list of approvers that only contains the "restricted" cost centers */
  public approvers: IApproverList[] = [];
  public selectOptions: ISelectOptions[] = [];

  constructor(private readonly datahub: DatahubService) {
    datahub.apiService.getApprovers$().subscribe({
      next: (approverData) => {
        this.init(approverData);
      },
      error: (err) => {
        console.error('Error fetching approvers:', err);
      },
    });
  }

  public getApprover$(empID: string): Observable<sharedApi.IWebServerResponseApprover> {
    return this.datahub.apiService.getApproverData$(empID);
  }

  public restrictList(costCenters: string[]): void {
    //Unless any of the cost centers is an admin cost center,
    //then reduce/restrict the list down to only approvers with the pass in cost centers
    if (!costCenters.some((cc) => cc === COST_CENTER_IT_PRODUCT_DEVELOP || cc === COST_CENTER_IT_PRODUCT_DEVELOP)) {
      this.approvers = this.findApproversInCostCenters(this.approvers, costCenters);
    }
  }

  private findApproversInCostCenters(approversList: IApproverList[], costCenters: string[]): IApproverList[] {
    const filteredApprovers: IApproverList[] = [];

    approversList.forEach((approver: IApproverList) => {
      let isFound = false;
      //See if the current approver exists in the cost center
      approver.costCenters.forEach((cc: string) => {
        if (costCenters.some((x) => x === cc)) isFound = true;
      });
      if (isFound) filteredApprovers.push(approver);
    });
    return filteredApprovers;
  }

  public getSelectOptionsByCostCenter(costCenter: string): ISelectOptions[] {
    return this.buildSelectOptions(this.allApprovers.filter((x) => x.costCenters.includes(costCenter)));
  }

  private init(approverArray: IApproverList[]): void {
    this.approvers = approverArray;
    this.allApprovers = this.approvers;
    this.selectOptions = this.buildSelectOptions(this.approvers);
  }

  private buildSelectOptions(approvers: IApproverList[]): ISelectOptions[] {
    return approvers.map((x) => ({
      value: x.value,
      description: x.display,
    }));
  }
}

export interface IApproverList extends sharedApi.IWebServerResponseApproverList {
  displaySecondary?: string;
}
